import { Controller } from "@hotwired/stimulus";

// Long enough that a normal typing burst results in a single request.
const SUBMIT_DELAY_MS = 800;
const FOCUS_STORAGE_KEY = "query-filter-focus";

export default class extends Controller {
  static targets = ["input", "clear"];

  connect() {
    this.refreshClear();
    this.restoreFocus();
  }

  disconnect() {
    clearTimeout(this.submitTimeout);
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.submit();
    }
  }

  // Applying the query reloads the page, so remember that the user was typing and put
  // them back in the field afterwards.
  submitDebounced() {
    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      sessionStorage.setItem(FOCUS_STORAGE_KEY, this.storageKey);
      this.submit();
    }, SUBMIT_DELAY_MS);
  }

  clear() {
    this.inputTarget.value = "";
    this.refreshClear();
    this.submit();
  }

  refreshClear() {
    if (this.hasClearTarget) {
      this.clearTarget.hidden = this.inputTarget.value === "";
    }
  }

  submit() {
    clearTimeout(this.submitTimeout);
    this.element.closest("form").requestSubmit();
  }

  restoreFocus() {
    if (sessionStorage.getItem(FOCUS_STORAGE_KEY) !== this.storageKey) return;

    sessionStorage.removeItem(FOCUS_STORAGE_KEY);
    this.inputTarget.focus();
    const caretPosition = this.inputTarget.value.length;
    this.inputTarget.setSelectionRange(caretPosition, caretPosition);
  }

  // Scopes the remembered focus to this field, so a form with more than one query filter
  // doesn't steal it from another.
  get storageKey() {
    return this.inputTarget.name;
  }
}
